<!--
  Header chrome (bell/title/mute/"turn on sound"/collapse) now lives on the
  dock that hosts this component (RequestsTasksDock) — one shared header
  for both the Requests and Tasks tabs, rather than each having its own
  (mute and audioBlocked in particular are ONE shared AlarmService signal
  pair; two independent "Turn on sound" prompts and mute buttons for the
  same underlying state was actually confusing, not just redundant). This
  is body-only content now: the list, or an empty state. The escalation
  engine in request-alerts.ts (rounds/speech/kick/loop) is untouched — only
  this template shrank.
-->
<section class="nv-alerts" [class.nv-alerts--overdue]="hasOverdue()" role="status" aria-live="polite">
  @if (count() === 0 && acknowledgedRequests().length === 0) {
    <div class="nv-alerts__empty">
      <p class="nv-alerts__empty-title">Nothing waiting</p>
      <p class="nv-alerts__empty-note">No guest is waiting on the floor.</p>
    </div>
  } @else {
    <ul class="nv-alerts__list nvx-scroll">
      @for (request of pending(); track request.id) {
        <li class="nv-alert" [class.nv-alert--overdue]="isOverdue(request)">
          <nv-icon class="nv-alert__icon">{{ icon(request) }}</nv-icon>

          <div class="nv-alert__text">
            <span class="nv-alert__table">{{ tableLabel(request) }}</span>
            <span class="nv-alert__reason">{{ label(request) }}</span>
            @if (request.note) {
              <span class="nv-alert__note">“{{ request.note }}”</span>
            }
          </div>

          <span class="nv-alert__waiting">{{ waitingFor(request) }}</span>

          @if (request.reason === 'pin_reset' && canSetPin()) {
            <button type="button" nvButton="primary" size="xs" class="nv-alert__ack" (click)="openSetPin(request)">
              Set PIN
            </button>
          }
          @if (request.reason === 'water' && canAddWater()) {
            <button
              type="button"
              nvButton="primary"
              size="xs"
              class="nv-alert__ack"
              [disabled]="acknowledging() === request.id"
              (click)="addWater(request)"
            >
              {{ acknowledging() === request.id ? 'Adding…' : 'Add water' }}
            </button>
          } @else {
            <button
              type="button"
              nvButton="primary"
              size="xs"
              class="nv-alert__ack"
              [disabled]="acknowledging() === request.id"
              (click)="acknowledge(request)"
            >
              {{ acknowledging() === request.id ? 'Acknowledging…' : 'Acknowledge' }}
            </button>
          }
        </li>
      }
      <!-- QA round 2, item I.1 — acknowledged-but-not-done requests get their
           own quiet row: no overdue styling, no alarm participation, just a
           way to close them out. -->
      @for (request of acknowledgedRequests(); track request.id) {
        <li class="nv-alert nv-alert--done">
          <nv-icon class="nv-alert__icon">{{ icon(request) }}</nv-icon>

          <div class="nv-alert__text">
            <span class="nv-alert__table">{{ tableLabel(request) }}</span>
            <span class="nv-alert__reason">{{ label(request) }} — acknowledged</span>
            @if (request.note) {
              <span class="nv-alert__note">“{{ request.note }}”</span>
            }
          </div>

          <button
            type="button"
            nvButton="secondary"
            size="xs"
            class="nv-alert__ack"
            [disabled]="markingDone() === request.id"
            (click)="markDone(request)"
          >
            {{ markingDone() === request.id ? 'Marking done…' : 'Mark done' }}
          </button>
        </li>
      }
    </ul>
  }
</section>
